import React, { useState, useEffect, ChangeEvent } from 'react';
import { TextField, InputAdornment, IconButton, Button, Box, Typography, Card, CardContent } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Email from '@mui/icons-material/Email';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import Lock from '@mui/icons-material/Lock';

import LoginIcon from '@mui/icons-material/Login';
import awlogo from "../Assets/images/Group 16808.png";
import { toast, Zoom } from 'react-toastify';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate, useLocation } from 'react-router-dom';
import axios, { AxiosError } from 'axios';
import { clinicalModel, profileModel } from '../Axios/AxiosConfig';
import { setTokens, saveUserDetails } from './AuthUtil';
import OTPInput from 'react-otp-input';
import { Auth_URL } from '../Axios/config';

interface Errors {
  emailOrPhone?: string;
  password?: string;
}

type LoginMethod = 'LoginWithPassword' | 'LoginWithOTP';

function Login() {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [user, setUser] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [errors, setErrors] = useState<Errors>({});
  const [SignupMethod, setSignUpMethod] = useState<'Email' | 'Phone'>('Email');
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isAutenicationModal, setIsAutenicationModal] = useState<boolean>(false);
  const [isOTPModal, setOTPModal] = useState<boolean>(false);
  const [OTPSession, SetOTPSession] = useState<string>('');
  const [isPasswordModal, setPasswordModal] = useState<boolean>(false);
  const [timer, setTimer] = useState<number>(0);
  const [isOTPloading, setOTPLoading] = useState<boolean>(false);
  const [isWaiting, setIsWaiting] = useState<boolean>(false);
  const [otp, setOtp] = useState<string>('');
  const [loadingType, setLoadingType] = useState<LoginMethod | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [passwordButtonLoading, setPasswordButtonLoading] = useState<boolean>(false);
  const [otpButtonLoading, setOtpButtonLoading] = useState<boolean>(false);
  const [verifyAccountButtonLoading, setVerifyAccountButtonLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleClickShowPassword = () => setShowPassword(show => !show);

  const CheckEmailOrPhone = (input: string): 'Email' | 'Phone' => {
    return !isNaN(Number(input)) && input.trim() !== '' ? 'Phone' : 'Email';
  };

  const addCountryCodeIfNumber = (input: string): string => {
    return !isNaN(Number(input)) && input.trim() !== '' ? '+91' + input : input;
  };

  const validate = (): boolean => {
    let tempErrors: Errors = {};
    const emailRegex = /^\S+@\S+\.\S+$/;
    const phoneRegex = /^[0-9]{10}$/;
    if (!emailRegex.test(user) && !phoneRegex.test(user)) {
      tempErrors.emailOrPhone = 'Please enter a valid email address or phone number';
    }
    setErrors(tempErrors);
    return Object.values(tempErrors).every(x => x === '');
  };

  const validateInput = (): boolean => {
    if (otp.length === 6) return true;
    setError('Invalid input. Please enter a valid 6 digit OTP');
    return false;
  };

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    setErrors({ ...errors, password: '' });
  };

  const handleEmailOrPhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    setUser(e.target.value);
    setErrors({ ...errors, emailOrPhone: '' });
  };

  const maskFirstChars = (str: string, numChars: number): string => {
    if (!str || str.length <= numChars) return '*'.repeat(str.length);
    return '*'.repeat(numChars) + str.slice(numChars);
  };

  // All your async functions (handleLogin, handleVerify, handleSubmit, etc.)
  // remain the same, but annotate any parameters with types where needed

  useEffect(() => {
    let countdown: NodeJS.Timeout;
    if (isWaiting && timer > 0) {
      countdown = setInterval(() => setTimer(prev => prev - 1), 1000);
    } else if (timer === 0 && isWaiting) {
      setIsWaiting(false);
    }
    return () => clearInterval(countdown);
  }, [timer, isWaiting]);





  // const handleSubmit = (LoginMethod) => {
  //   if (LoginMethod === "LoginWithPassword") {
  //     setPasswordModal(true);

  //     setError('');
  //   }
  //   else {

  //     handlePasswordlessLogin();
  //     setError('');
  //   }
  // };



  const handleSubmit = async (LoginMethod: any) => {
    if (loadingType) return;

    try {

      setLoadingType(LoginMethod);

      if (LoginMethod === "LoginWithPassword") {
        setPasswordModal(true);
      } else {
        await handlePasswordlessLogin();
      }

      setError('');
    } catch (error: any) {
      console.error("Login error:", error);
    } finally {
      setLoadingType(null);
    }
  };



  const getProfile = async (id: any) => {
    try {
      let res = await clinicalModel.get(`/Profile/${id}`);

      if (res.status === 200) {
        const profile = res?.data;

        const { firstname, lastname, email, phone, role } = profile;

        if (profile) {

          if (role?.includes('user')) {
            toast.error('You are not authorized to login', {
              position: 'top-center',
              transition: Zoom,
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark'
            });
          }

          else if (role?.includes('admin')) {
            navigate('/')
          }



          else {
            toast.error('You are not authorized to login', {
              position: 'top-center',
              transition: Zoom,
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark'
            });
          }

        }

        else {
          toast.error('You are not authorized to login', {
            position: 'top-center',

            transition: Zoom,
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark'
          });
        }

        saveUserDetails(firstname, lastname, email, phone, id, role)

      }
    }
    catch (err) {
      console.log(err);
    }
  }

  const handleVerify = async () => {
    if (!validateInput()) return;

    try {
      setOtpButtonLoading(true);

      let res = await axios.post(`${Auth_URL}verify-Passwordless-signin`, {
        user: addCountryCodeIfNumber(user),
        session: OTPSession,
        otp
      });

      if (res.status === 200) {
        const { accessToken, refreshToken, id } = res.data;
        setTokens(accessToken, refreshToken);
        await getProfile(id);

      }

    }

    catch (err: any) {
      if (err.response.status === 500) {

        toast.error(err?.response?.data?.name, {
          position: 'top-center',
          transition: Zoom,
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark'
        });

        setError(err?.response?.data?.error);

        // if (err?.response?.data?.error === "NotAuthorizedException") {
        //   toast.error(err?.response?.data?.name, {
        //     position: 'top-center',
        //     limit: 1,
        //     transition: Zoom,
        //     autoClose: 2000,
        //     hideProgressBar: false,
        //     closeOnClick: false,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        //     theme: 'dark'
        //   });
        // }
        // else {

        // }

      }
    }

  }

  const handlePasswordlessLogin = async () => {
    try {
      setOtpButtonLoading(true);
      
      const response = await axios.post(`${Auth_URL}Passwordless-Signin`, {
        user: addCountryCodeIfNumber(user)
      });

      if (response.status === 200) {
        SetOTPSession(response.data.session);
        setOTPModal(true);
        setIsWaiting(true);
        setTimer(30);
      }
    } catch (error: any) {
      console.error('Passwordless login error:', error);
      setError(error.response?.data?.message || 'Failed to initiate passwordless login');
    } finally {
      setOtpButtonLoading(false);
    }
  };

  const handleVerifyLogin = async () => {
    try {
      setOtpButtonLoading(true);
      
      const response = await axios.post(`${Auth_URL}verify-Passwordless-signin`, {
        user: addCountryCodeIfNumber(user),
        session: OTPSession,
        otp
      });

      if (response.status === 200) {
        const { accessToken, refreshToken, id } = response.data;
        setTokens(accessToken, refreshToken);
        await getProfile(id);
      }
    } catch (error: any) {
      console.error('Verify login error:', error);
      setError(error.response?.data?.message || 'Verification failed');
    } finally {
      setOtpButtonLoading(false);
    }
  };

  const handleVerifyAccount = async () => {
    try {
      setVerifyAccountButtonLoading(true);

      let res = await axios.post(`${Auth_URL}VerfiyAccount`, {
        user: addCountryCodeIfNumber(user),
        code: otp,
        password
      });

      if (res.status == 200) {
        handleVerifyLogin();
        setIsAutenicationModal(false);
      }
    } catch (err: any) {
      if (err.response.status === 500) {
        setError(err?.response?.data?.error);
        console.log(err?.response?.data);
      }
    } finally {
      setVerifyAccountButtonLoading(false);
    }
  }

  const toggleModal = () => {
    setIsAutenicationModal(!isAutenicationModal);
  };

  const handleResend = async () => {
    try {
      let res = await axios.post(`${Auth_URL}Resend-Confirmation-code`, {
        user: addCountryCodeIfNumber(user),
      });

      if (res.status === 200) {
        setIsWaiting(true);
        setTimer(30);
        setOtp('');
        setError('');
      }
    }
    catch (err: any) {
      if (err.response.status === 500) {
        setError(err?.response?.data?.error);
        console.log(err?.response?.data);
      }
    }
  }

  const handleLogin = async () => {
    try {
      setPasswordButtonLoading(true);

      let res = await axios.post(`${Auth_URL}Signin`, {
        email: addCountryCodeIfNumber(user),
        password
      });

      if (res.status === 200) {

        const { accessToken, refreshToken, id } = res.data;

        setTokens(accessToken, refreshToken);

        await getProfile(id);

        // const { state } = location;

        // if (state?.from) {
        //   navigate(state.from);
        // } else {
        //   navigate('/');
        // }

      }
    } catch (err: any) {
      if (err.response.status === 500) {
        setError(err?.response?.data?.error);
        if (err?.response?.data?.name === "NotAuthorizedException") {
          toast.error("Please enter the correct password.", {
            position: 'top-center',
            transition: Zoom,
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark'
          });
        }
        else {
          toast.error(err?.response?.data?.name, {
            position: 'top-center',
            transition: Zoom,
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark'
          });
        }
      }
    } finally {
      setPasswordButtonLoading(false);
    }
  };

  const toggleModal1 = () => {
    setIsModalVisible(!isModalVisible);
  };

  const toggleModal2 = () => {
    setPasswordModal(!isPasswordModal);
  };

  const toggleModal3 = () => {
    setOTPModal(!isOTPModal);
  };

  useEffect(() => {
    const ac = new AbortController();
    const timeout = setTimeout(() => ac.abort(), 30000);

    if (isOTPModal && 'OTPCredential' in window) {
      (navigator.credentials as any)
        .get({ otp: { transport: ['sms'] }, signal: ac.signal })
        .then((otpCredential: any) => {
          if (otpCredential) {
            setOtp(otpCredential.code);
            handleVerify();
          }
        })
        .catch((err: any) => console.log(`OTP Error: ${err}`));
    }

    return () => {
      clearTimeout(timeout);
      ac.abort();
    };
  }, [isOTPModal]);

  const validateuser = async (method: any) => {

    if (validate()) {

      setLoading(true)

      setLoadingType(method)

      try {
        let res = await axios.post(`${Auth_URL}validate-user`, {
          user: addCountryCodeIfNumber(user)
        })

        if (res.status === 200) {
          handleSubmit(method)
          setLoading(false)
        }
      }

      catch (err: any) {

        toast.error(err?.response?.data?.error, {
          position: 'top-center',
          transition: Zoom,
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark'
        });

        if (err?.response?.data?.error === 'User Account not verified') {
          setIsAutenicationModal(true)
          handleResend()
        }

      }

      finally {
        setLoading(false)
        setLoadingType(null)
      }
    }
  }

  return (
    <Box 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#F4ECD6', // blondecurl200
        p: 2
      }}
    >
      <Card 
        elevation={3} 
        sx={{
          width: '100%',
          maxWidth: 480,
          borderRadius: 3,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
          bgcolor: '#F8F2E3', // blondecurl300
          border: '1px solid #E7E7DB' // blondecurl
        }}
      >
        <Box component="img" 
          src="https://ayurai.io/static/media/Logo%204.3c494c46f399ed538ec9.png" 
          alt="Ayurai" 
          sx={{ 
            height: 46, 
            objectFit: 'contain',
            mb: 2,
            filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.1))'
          }} 
        />
        <Box sx={{ textAlign: 'center', mb: 3, width: '100%' }}>
          <Typography variant="h4" component="h1" sx={{ 
            fontWeight: 600, 
            color: '#3B362A', // sensaichabrown
            mb: 1,
            letterSpacing: '0.5px'
          }}>
            Welcome Back
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#75623F', // YellowMetal
            fontSize: '0.95rem'
          }}>
            Sign in to continue to your dashboard
          </Typography>
        </Box>
        <Box sx={{ width: '100%', maxWidth: 320, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            value={user}
            onChange={handleEmailOrPhoneChange}
            placeholder={"Enter mobile number/ Mail id"}
            error={!!errors.emailOrPhone}
            fullWidth
            variant="outlined"
            helperText={errors.emailOrPhone}
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'white',
                borderRadius: '8px',
                '&.Mui-focused fieldset': {
                  borderColor: '#75623F', // YellowMetal
                  borderWidth: '1px',
                },
                '&:hover fieldset': {
                  borderColor: '#C6B897', // YellowMetallight
                },
              },
              '& .MuiFormHelperText-root': {
                color: '#DA6E0B', // goldorange
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LoginIcon sx={{ color: '#75623F' }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {!isModalVisible && !isPasswordModal && !isOTPModal && !isAutenicationModal && (
          <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
            <div>
              <Button
                fullWidth
                variant="contained"
                onClick={() => validateuser('LoginWithPassword')}
                disabled={loadingType === 'LoginWithPassword'}
                sx={{
                  textTransform: 'none',
                  backgroundColor: '#DA6E0B', // goldorange
                  color: 'white',
                  borderRadius: '8px',
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 500,
                  py: 1.5,
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: '#E69E5C', // goldorange300
                    boxShadow: 'none',
                  },
                  '&.Mui-disabled': {
                    backgroundColor: '#FBF1E7', // goldorange50
                    color: '#E69E5C' // goldorange300
                  }
                }}
              >
                {loadingType === 'LoginWithPassword' ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Login with Password'
                )}
              </Button>
          </div>

          <Button
            fullWidth
            variant="outlined"
            onClick={() => validateuser('LoginWithOTP')}
            disabled={loadingType === 'LoginWithOTP'}
            sx={{
              textTransform: 'none',
              borderColor: '#75623F', // YellowMetal
              color: '#75623F', // YellowMetal
              borderRadius: '8px',
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 500,
              py: 1.5,
              '&:hover': {
                borderColor: '#C6B897', // YellowMetallight
                backgroundColor: 'rgba(198, 184, 151, 0.1)', // YellowMetallight with opacity
              },
              '&.Mui-disabled': {
                borderColor: '#E7E7DB', // blondecurl
                color: '#C6B897' // YellowMetallight
              }
            }}
          >
            {loadingType === 'LoginWithOTP' ? (
              <CircularProgress size={24} sx={{ color: '#DA6E0B' }} />
            ) : (
              'Login with OTP'
            )}
          </Button>

          {/* <div className="flex flex-row justify-center items-center gap-5 Signuptermsandcondition hidden ]">
            <p style={{ color: '#75623F' }}>If you didn't have an account</p>
            <p
              style={{
                fontWeight: '500',
                color: '#75623F',
                borderBottom: '1px solid #75623F',
                cursor: 'pointer'
              }}
              onClick={() => { navigate('/Signup'); }}
            >
              Sign Up
            </p>
          </div> */}
        </Box>
        )}
        {isModalVisible && (
              <CardContent>
                <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1 }}>
                  Step 2 · Verify Authentication Code
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Authentication Code
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  {CheckEmailOrPhone(user) === 'Email'
                    ? `Enter the 6 digit code sent to your mail id ending with ${maskFirstChars(user, 6)}`
                    : `Enter the 6 digit code sent to your mobile number ${maskFirstChars(user, 6)}`}
                </Typography>

                <Box className='login-otp-text-input' sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <OTPInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    inputStyle={{
                      border: '1px solid transparent',
                      borderRadius: '8px',
                      width: '54px',
                      height: '54px',
                      fontSize: '16px',
                      color: '#000',
                      fontWeight: '500',
                      outline: '1px solid silver',
                      caretColor: 'blue',
                    }}
                    renderSeparator={<span style={{ visibility: 'hidden' }}>--</span>}
                    renderInput={(props: any) => <input {...props} autoComplete="one-time-code" />}
                  />

                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography
                      variant="body2"
                      sx={{ visibility: isWaiting ? 'visible' : 'hidden', color: 'text.secondary' }}
                    >
                      {timer} s
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: '#DA6E0B', cursor: 'pointer', fontWeight: 500 }}
                      onClick={handleResend}
                    >
                      Resend Code
                    </Typography>
                  </Box>

                  {error && (
                    <Typography variant="body2" sx={{ color: 'error.main' }}>
                      {error}
                    </Typography>
                  )}

                  <Button
                    fullWidth
                    sx={{
                      mt: 1,
                      textTransform: 'none',
                      backgroundColor: '#DA6E0B',
                      color: 'white',
                      borderRadius: 1.5,
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: 500,
                      py: 1.1,
                    }}
                    onClick={handleVerify}
                  >
                    {otpButtonLoading ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                        <CircularProgress size={20} sx={{ color: 'inherit' }} />
                        <span>Verifying...</span>
                      </Box>
                    ) : (
                      'Verify Account'
                    )}
                  </Button>
                </Box>
              </CardContent>
        )}

        {isPasswordModal && (
              <CardContent>
                <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1 }}>
                  Step 2 · Enter Password
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Enter Password
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Please correctly enter the password that you used in sign up.
                </Typography>

                <TextField
                  style={{ margin: '1rem 0 0' }}
                  value={password}
                  onChange={handlePasswordChange}
                  placeholder="Password"
                  type={showPassword ? 'text' : 'password'}
                  error={!!errors.password}
                  helperText={errors.password}
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: '#DA6E0B',
                      },
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword}>
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <Box
                  className='login-otp-text-input-div'
                  sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}
                >
                  <Typography
                    variant="body2"
                    sx={{ visibility: isWaiting ? 'visible' : 'hidden', color: 'text.secondary' }}
                  >
                    {timer} s
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{ color: '#DA6E0B', cursor: 'pointer', fontWeight: 500 }}
                    onClick={() => {
                      navigate(`/ForgotPassword/${user}`);
                    }}
                  >
                    Forgot Password
                  </Typography>
                </Box>

                {error && (
                  <Typography variant="body2" sx={{ color: 'error.main', mt: 1 }}>
                    {error}
                  </Typography>
                )}

                <Button
                  fullWidth
                  sx={{
                    mt: 2,
                    textTransform: 'none',
                    backgroundColor: '#DA6E0B',
                    color: 'white',
                    borderRadius: 1.5,
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 500,
                    py: 1.1,
                  }}
                  onClick={handleLogin}
                >
                  {passwordButtonLoading ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                      <CircularProgress size={20} sx={{ color: 'inherit' }} />
                      <span>Logging in...</span>
                    </Box>
                  ) : (
                    'Login'
                  )}
                </Button>
              </CardContent>
        )}

        {/* OTP Verification Modal */}
        {isOTPModal && (
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Authentication Code
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  {CheckEmailOrPhone(user) === 'Email'
                    ? `Enter the 6 digit code sent to your mail id ending with ${maskFirstChars(user, 6)}`
                    : `Enter the 6 digit code sent to your mobile number ${maskFirstChars(user, 6)}`}
                </Typography>

                <Box className='login-otp-text-input' sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box className='login-otp-text-input-div'>
                    <OTPInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      inputStyle={{
                        border: '1px solid transparent',
                        borderRadius: '8px',
                        width: '54px',
                        height: '54px',
                        fontSize: '16px',
                        color: '#000',
                        fontWeight: '500',
                        outline: '1px solid silver',
                        caretColor: 'blue',
                      }}
                      renderSeparator={<span style={{ visibility: 'hidden' }}>--</span>}
                      renderInput={(props: any) => <input {...props} autoComplete="one-time-code" />}
                    />
                  </Box>

                  <Box className='login-otp-text-input-div' sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                    <Typography
                      variant="body2"
                      sx={{ visibility: isWaiting ? 'visible' : 'hidden', color: 'text.secondary' }}
                    >
                      {timer} s
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ color: '#DA6E0B', cursor: 'pointer', fontWeight: 500 }}
                      onClick={handlePasswordlessLogin}
                    >
                      Resend Code
                    </Typography>
                  </Box>

                  {error && (
                    <Typography variant="body2" sx={{ color: 'error.main' }}>
                      {error}
                    </Typography>
                  )}

                  <Box className='login-otp-text-input-div'>
                    <Button
                      fullWidth
                      sx={{
                        mt: 1,
                        textTransform: 'none',
                        backgroundColor: '#DA6E0B',
                        color: 'white',
                        borderRadius: 1.5,
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        py: 1.1,
                      }}
                      onClick={handleVerify}
                    >
                      {otpButtonLoading ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                          <CircularProgress size={20} sx={{ color: 'inherit' }} />
                          <span>Verifying...</span>
                        </Box>
                      ) : (
                        'Login'
                      )}
                    </Button>
                  </Box>
                </Box>
              </CardContent>
        )}


        {isAutenicationModal && (
              <CardContent>
                <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1 }}>
                  Step 3 · Verify Account
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Verify Account
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  {SignupMethod === 'Email'
                    ? `Enter the 6 digit code sent to your mail id ending with ${maskFirstChars(user, 6)}`
                    : `Enter the 6 digit code sent to your mobile number ${maskFirstChars(user, 6)}`}
                </Typography>

                <Box className='login-otp-text-input' sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <TextField
                    style={{ margin: '1rem 0 0' }}
                    value={password}
                    onChange={handlePasswordChange}
                    placeholder="Password"
                    type={showPassword ? 'text' : 'password'}
                    error={!!errors.password}
                    helperText={errors.password}
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: '#DA6E0B',
                        },
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Lock />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword}>
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <Box className='login-otp-text-input-div'>
                    <OTPInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      inputStyle={{
                        border: '1px solid transparent',
                        borderRadius: '8px',
                        width: '54px',
                        height: '54px',
                        fontSize: '16px',
                        color: '#000',
                        fontWeight: '500',
                        outline: '1px solid silver',
                        caretColor: 'blue',
                      }}
                      renderSeparator={<span style={{ visibility: 'hidden' }}>--</span>}
                      renderInput={(props: any) => <input {...props} />}
                    />
                  </Box>

                  <Box className='login-otp-text-input-div' sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                    <Typography
                      variant="body2"
                      sx={{ visibility: isWaiting ? 'visible' : 'hidden', color: 'text.secondary' }}
                    >
                      {timer} s
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ color: '#DA6E0B', cursor: 'pointer', fontWeight: 500 }}
                      onClick={handleResend}
                    >
                      Resend Code
                    </Typography>
                  </Box>

                  {error && (
                    <Typography variant="body2" sx={{ color: 'error.main' }}>
                      {error}
                    </Typography>
                  )}

                  <Box className='login-otp-text-input-div'>
                    <Button
                      fullWidth
                      sx={{
                        mt: 1,
                        textTransform: 'none',
                        backgroundColor: '#DA6E0B',
                        color: 'white',
                        borderRadius: 1.5,
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        py: 1.1,
                      }}
                      onClick={handleVerifyAccount}
                    >
                      {verifyAccountButtonLoading ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                          <CircularProgress size={20} sx={{ color: 'inherit' }} />
                          <span>Verifying...</span>
                        </Box>
                      ) : (
                        'Verify'
                      )}
                    </Button>
                  </Box>
                </Box>
              </CardContent>
        )}

      </Card>
    </Box>
  );
}

export default Login;
